import React from 'react';
import cx from 'classnames';
import { login } from './authentication';
import styles from './not-authenticated.module.css';
import InfoTile from '../components/infotile/info-tile';
import LinkButton from '../components/button/link-button';
import { getTranslation, getTranslationHtml } from '../locales/i18n';

const NotAuthenticated: React.FC<any> = () => (
  <section className="vl-region">
    <div className="vl-layout">
      <div className={cx('vl-introduction', styles.introductionsmall)}>
        <h2 className="vl-title vl-title--h2" data-cy="page-title">
          {getTranslation('not-authenticated.title')}
        </h2>
        <p>{getTranslationHtml('not-authenticated.description')}</p>
        <h3 className="vl-title vl-title--h3">{getTranslation('not-authenticated.registration.title')}</h3>
        <p>{getTranslationHtml('not-authenticated.registration.manual')}</p>
        <h4 className="vl-title vl-title--h4">{getTranslation('not-authenticated.registration.belgianOrg.title')}</h4>
        {getTranslationHtml('not-authenticated.registration.belgianOrg.description')}
        <div className="vl-grid vl-grid--is-stacked vl-u-spacer-bottom">
          <div className="vl-col--4-12">
            <InfoTile title={getTranslation('not-authenticated.registration.authorised.title')}>
              <p className={styles.introductionsmall}>
                {getTranslation('not-authenticated.registration.authorised.description', { login: '' })}
                <LinkButton handleClick={login}>{getTranslation('button.login')}</LinkButton>.
              </p>
            </InfoTile>
          </div>
          <div className="vl-col--4-12">
            <InfoTile title={getTranslation('not-authenticated.registration.acmidm.title')}>
              <div className={styles.introductionsmall}>
                <div className="vl-typography">{getTranslationHtml('not-authenticated.registration.acmidm.description')}</div>
              </div>
            </InfoTile>
          </div>
          <div className="vl-col--4-12">
            <InfoTile title={getTranslation('not-authenticated.registration.telephone.title')}>
              <div className={styles.introductionsmall}>{getTranslationHtml('not-authenticated.registration.telephone.description')}</div>
            </InfoTile>
          </div>
        </div>
        <br />
        <h4 className="vl-title vl-title--h4">{getTranslationHtml('not-authenticated.registration.office.title')}</h4>
        <p>{getTranslationHtml('not-authenticated.registration.office.description')}</p>
        <h4 className="vl-title vl-title--h4">{getTranslationHtml('not-authenticated.registration.ovam-laa.title')}</h4>
        <p>{getTranslationHtml('not-authenticated.registration.ovam-laa.description')}</p>
        <p className="vl-u-text--italic">{getTranslation('not-authenticated.disclaimer')}</p>
      </div>
    </div>
  </section>
);

export default NotAuthenticated;
